<template>
  <div id="google-auth-button">
    <div class="google-icon"></div>
    <div class="google-text">Login with Google</div>
  </div>
</template>

<script>
export default {
  props: {
    callback: Function,
  },
  computed: {
    gapi() {
      return window.gapi;
    },
  },
  methods: {
    loadGoogleAuth() {
      if (!this.gapi) return;
      this.gapi.load('auth2', this.initGoogleAuth);
    },
    initGoogleAuth() {
      const auth = window.gapi.auth2.init({
        client_id: '157058039662-gqod9r11ofijnb6jcqubgkl1c0sqippf.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope: 'email profile',
      });

      const el = document.getElementById('google-auth-button');
      auth.attachClickHandler(el, {}, this.success, this.failure);
    },
    success(googleUser) {
      const token = googleUser.getAuthResponse().access_token;
      this.callback(token);
    },
    failure() {
      // console.error(error);
    },
  },
  watch: {
    gapi: {
      immediate: true,
      handler: 'loadGoogleAuth',
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#google-auth-button {
  margin-top: 10px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  height: 40px;
  width: 306px;
  background-color: #4285F4;
  border-color: #4285F4;
  color: white;
  cursor: pointer;
}

.google-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  border-radius: 50%;
  background-image: url("~icons/google.svg");
  background-color: white;
  border-color: white;
  transform: scale(0.8);
  margin-left: 5px;
}
.google-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 16px;
  margin-left: -47px;
}
</style>




// WEBPACK FOOTER //
// src/components/GoogleLogin.vue